module.exports = __webpack_public_path__ + "img/12hao.0cbe6f87.png";